import { render } from "./VueGoogleAutocomplete.vue?vue&type=template&id=53422fc4"
import script from "./VueGoogleAutocomplete.vue?vue&type=script&lang=js"
export * from "./VueGoogleAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/mdhub-web/mdhub-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__